const COLORS = {
    DARK_GREY: '#2d2d2d',
    SPINNER: '#6610f2',
    INPUT_ERROR: '#ff4444',
    WHITE: '#ffffff',
    headerColor: '#113371',
    ACTIVE_BUTTON: '#36b2e9',
    PROPERTY_PANEL: '#f8f8f8',
};

export default COLORS;
